export const formatDate = (now, flag) => {
  const Dates = new Date(now);
  const year = Dates.getFullYear();
  let month = Dates.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let date = Dates.getDate();
  date = date > 9 ? date : "0" + date;
  const hour = Dates.getHours();
  const minute = Dates.getMinutes();
  const second = Dates.getSeconds();
  if (flag) return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  else return year + "-" + month + "-" + date;
};

/**
 * 日期 时间戳转换成yy年mm月dd日 || yy-mm-dd
 * item:日期
 * flag = 0 转换 yy年mm月dd日
 * flag = 1 转换 yy-mm-dd
 */
export const conversionDate = (item, flag) => {
  const date = new Date(item);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  if (flag) {
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    return y + "-" + m + "-" + d;
  } else {
    return m + "月" + d + "日";
  }
};
/**
 * @param 日期 yy-mm-dd转换成yy年mm月dd日
 */
export const changeDate = (date) => {
  const strArr = date.split("-");
  const y = strArr[0];
  const m = strArr[1];
  const d = strArr[2];
  return y + "年" + m + "月" + d + "日";
};

/**
 * 日期分别获取年月日
 * @param date 日期
 */
export const getYear = (date) => {
  const strArr = date.split("-");
  const y = strArr[0];
  return y;
};
export const getMonth = (date) => {
  const strArr = date.split("-");
  const m = strArr[1];
  return m;
};
export const getDay = (date) => {
  const strArr = date.split("-");
  const d = strArr[2];
  return d;
};
// GUID
// function getGuidGenerator(): string {
//   const S4 = (): string => {
//     const str = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
//     return str;
//   };
//   return S4() + S4() + S4();
// }
// localStorage本地存储
export function setItems(params, data) {
  return localStorage.setItem(params, JSON.stringify(data));
}
export function getItems(params) {
  const json = localStorage.getItem(params);
  if (json) {
    return JSON.parse(json);
  } else {
    return null; 
  }
}

// getBase64
// const getBase64 = (img: Blob, callback: (param: string | ArrayBuffer | null) => void) => {
//   if (img !== undefined && img != null) {
//     const reader = new FileReader();
//     reader.addEventListener("load", () => callback(reader.result));
//     reader.readAsDataURL(img);
//   }
// };

/**
 * @param 校验身份证号 idCard
 * @param 手机号 phone
 * @param 密码 password
 * @param 短信验证码 code
 * @param 单位名称 regName
 * @param 组织机构代码 orgCode
 * @param 用户名 uname
 * @param 姓名 contactname
 */
import { common } from "./regex";
export const isCheck = (value, key) => {
  const LowerCase = key.toLowerCase();
  if (LowerCase === "phone" || LowerCase === "contactsphone") {
    if (value === "") return "请输入手机号";
    else {
      const flag = common.checkPhone(value);
      if (!flag) {
        return "手机号格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "idcard" || LowerCase === "contactscodeno") {
    if (value === "") return "请输入身份证号";
    else {
      const flag = common.isIDCard(value);
      if (!flag) {
        return "身份证号格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "code") {
    if (value === "") return "请输入短信验证码";
    else {
      const flag = common.checkCode(value);
      if (!flag) {
        return "短信验证码格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "password" || LowerCase === "oldpassword" || LowerCase === "newpassword") {
    if (value === "") return "请输入密码";
    else {
      const flag = common.isPassword(value);
      if (!flag) {
        return "密码格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "regname" || LowerCase === "organizationname") {
    if (value === "") return "请输入单位名称";
    else {
      const flag = common.checkregName(value);
      if (!flag) {
        return "单位名称格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "orgcode") {
    if (value === "") return "请输入组织机构代码";
    else {
      const flag = common.isOrganizationCode(value);
      if (!flag) {
        return "组织机构代码格式不正确";
      } else return "";
    }
  }
  if (LowerCase === "uname") {
    if (value === "") return "请输入用户名";
    else {
      const flag = common.isUserName(value);
      if (!flag) {
        return "用户名格式不正确，请输入6-25个字符为字母或数字";
      } else return "";
    }
  }
  if (LowerCase === "contactname" || LowerCase === "contactsname" || LowerCase === "name") {
    if (value === "") return "请输入姓名";
    else {
      const flag = common.isNama(value);
      if (!flag) {
        return "姓名格式不正确，请输入2-16位的汉字";
      } else return "";
    }
  }
  if (LowerCase === "organizationaddress") {
    if (value === "") return "请输入地址";
    else {
      const flag = common.isAddressRegex(value);
      if (!flag) {
        return "地址格式不正确，请输入2-200位的汉字";
      } else return "";
    }
  }
};

/**
 * 星期几
 * @param dateNumber 0=周日，1=周一
 */
export const getWeek = (dateNumber) => {
  let day;
  switch (dateNumber) {
    case 0:
      day = "周日";
      break;
    case 1:
      day = "周一";
      break;
    case 2:
      day = "周二";
      break;
    case 3:
      day = "周三";
      break;
    case 4:
      day = "周四";
      break;
    case 5:
      day = "周五";
      break;
    case 6:
      day = "周六";
      break;
  }
  return day;
};

// cookie存取
export const addCookie = (objName, objValue, objHours) => {
  let str = objName + "=" + escape(objValue); // 编码
  if (objHours > 0) {
    // 为0时不设定过期时间，浏览器关闭时cookie自动消失
    const date = new Date();
    const ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += "; expires=" + date.toUTCString();
  }
  document.cookie = str;
};

export const getCookie = (objName) => {
  // 获取指定名称的cookie的值
  const arrStr = document.cookie.split("; ");
  // for (let i = 0; i < arrStr.length; i++) {
  //   const temp = arrStr[i].split("=");
  //   if (temp[0] == objName) return unescape(temp[1]); //解码
  // }
  for(const item of arrStr){
    const temp = item.split("=");
    if (temp[0] === objName) return unescape(temp[1]); // 解码
  }
  return "";
};
